import {
  INewTicketAutRecRuleArrivalRule,
  ITicketAutRecRuleArrivalRule,
} from "../models/ticket-aut-rec-rule-arrival-rule";
import { GlobalAxios } from "../axios/axios-config";

const TICKET_AUT_REC_RULE_ARRIVAL_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutRecRuleArrivalRule/";

export const createTicketAutRecRuleArrivalRule = (
  item: INewTicketAutRecRuleArrivalRule,
) => {
  return GlobalAxios.post(TICKET_AUT_REC_RULE_ARRIVAL_RULE_ROUTE, item);
};

export const getTicketAutRecRuleArrivalRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutRecRuleArrivalRule>(
    TICKET_AUT_REC_RULE_ARRIVAL_RULE_ROUTE + id,
  );
};

export const updateTicketAutRecRuleArrivalRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutRecRuleArrivalRule;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUT_REC_RULE_ARRIVAL_RULE_ROUTE + id, item);
};
